<script>
  /**
   * Dropdown delete button
   */

  import ConfirmButton from './ConfirmButton'

  export default {
    mixins: [ConfirmButton],

    props: {
      buttonType: {
        type: String,
        required: false,
        default: 'danger'
      },
      buttonText: {
        type: String,
        required: false,
        default: 'Delete'
      },
      confirmText: {
        type: String,
        required: false,
        default: 'Confirm Deletion'
      },
      dropup: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
    }
  }
</script>



// WEBPACK FOOTER //
// DeleteButton.vue?2be18f46